export default __webpack_public_path__ + "static/media/Ballroll_00127.7d4f8c31.png";